
import React, { Component } from "react";
import Config from "../../../config";
import { Modal, Button,Radio,Input,Checkbox } from 'antd';
import { tsDateToThaiDate } from "../../../utils/func";
const RadioGroup = Radio.Group;
const { TextArea } = Input;
class Xpage6ef06dc11 extends Component {
  constructor(props) {
    super(props);
    this.state = {modeLayout1 : false ,modeLayout2 : false ,data1:[],data2:[],visible1:false,visible2:false,visible3:false,m2:{}
    ,listTable : [
        {text: "ขั้นตอนที่ 1 คณะทำงานด้านการจัดการพลังงาน"},
        {text: "ขั้นตอนที่ 2 การประเมินสถานภาพการจัดการพลังงานเบื้องต้น"},
        {text: "ขั้นตอนที่ 3 นโยบายอนุรักษ์พลังงาน"},
        {text: "ขั้นตอนที่ 4 การประเมินศักยภาพการอนุรักษ์พลังงาน"},
        {text: "ขั้นตอนที่ 5 การกำหนดเป้าหมายและแผนอนุรักษ์พลังงาน การฝึกอบรมและกิจกรรมส่งเสริมการอนุรักษ์พลังงาน"},
        {text: "ขั้นตอนที่ 6 การดำเนินการตามแผนการอนุรักษ์พลังงาน การตรวจสอบและวิเคราะห์การปฏิบัติตามเป้าหมายและแผนฯ"},
        {text: "ขั้นตอนที่ 7  การตรวจติดตามและประเมินการจัดการพลังงาน"},
        {text: "ขั้นตอนที่ 8 การทบทวน วิเคราะห์ และแก้ไขข้อบกพร่องของการจัดการพลังงาน"},
    ] ,
    };
    let { year ,plt_bld_id } = this.props

    this.getDataLayoutAll(year ,plt_bld_id);
  }

    getDataLayoutAll(year ,plt_bld_id){
        this.getDataLayout1(year ,plt_bld_id)
        this.getDataLayout2(year ,plt_bld_id)
    }

    getDataLayout1(year ,plt_bld_id){
        let { time  } = this.props
        let token = localStorage.getItem("ef_token");
        return fetch(Config.api + `/api/getReport-ef06dc11-l1?token=${token}&plt_bld_id=${plt_bld_id}&year=${year}&xtime=${time}`, {
            headers: {"Content-Type": "application/json",}
            }).then(response => response.json())
            .then(data => {
                if(data.resultCode ==20000 && data.data){
                    this.setState({modeLayout1:'view',data1:data.data});

                     setTimeout(()=>{
                        let { listTable,data1 } = this.state;
                            listTable = listTable.map((r,i)=>{
                                    let d = {RESULT_FLAG:'',REMARK:''}
                                    for(let j in data1){
                                        if(data1[j].LIST_C == (i+1)+""){
                                            d = data1[j];
                                        }
                                    }
                                    d.UPDATE = false;
                                    return {...r,...d}
                                })
                                this.setState({listTable:listTable })

                    },50)
                }
                console.log("getData1",data);
            }, err => {
            console.log("getData1", err);
        });
    }

    getDataLayout2(year ,plt_bld_id){
         let { time  } = this.props
        let token = localStorage.getItem("ef_token");
        return fetch(Config.api + `/api/getReport-ef06dc11-l2?token=${token}&plt_bld_id=${plt_bld_id}&year=${year}&xtime=${time}`, {
            headers: {"Content-Type": "application/json",}
            }).then(response => response.json())
            .then(data => {
                if(data.resultCode ==20000 && data.data && data.data.length > 0){
                    this.setState({modeLayout2:'view',data2:data.data});
                }
                console.log("getData2",data);
            }, err => {
            console.log("getData2", err);
        });
    }
    insertUpdateDeleteDataLayout1($data){
            //  this.setState({visible1:false})
        let { step, plt_bld_id, year, time } = this.props
        let token = localStorage.getItem("ef_token");
        let data = { ...$data, token, step, plt_bld_id, year, time }
        return fetch(Config.api + `/api/postReport-ef04dc11-l1`, {
            method: 'POST', // or 'PUT'
            body: JSON.stringify(data), // data can be `string` or {object}!
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(response => response.json())
            .then((data) => {
                console.log(data.resultCode)
                if (data.resultCode == 20000) {
                    let { year, plt_bld_id } = this.props
                    this.getDataLayout1(year, plt_bld_id)
                    this.setState({ visible1: false, m1: {} })
                    if($data.update && $data.update.length > 0 || $data.insert && $data.insert.length > 0){
                        
                    }else{
                        
                    }
                    
                } else {
                    alert('error')
                }
            }, () => {
                alert('error')
            });
    }

    putDataLayout2() {
        let { step, plt_bld_id, year, time } = this.props
        let token = localStorage.getItem("ef_token");
        let { m2 } = this.state
        let data = { ...m2 , token, step, plt_bld_id, year, time }
        console.log('data', data)
        return fetch(Config.api + `/api/putReport-ef04dc11-l2`, {
            method: 'PUT', // or 'PUT'
            body: JSON.stringify(data), // data can be `string` or {object}!
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(response => response.json())
            .then((data) => {
                // console.log(data.resultCode)
                if (data.resultCode == 20000) {
                    let { year, plt_bld_id } = this.props

                    this.setState({ visible2: false, m2: {} })
                    this.getDataLayout2(year, plt_bld_id)
                } else {
                    alert('error')
                }
            }, () => {
                alert('error')
            })
        }
 
    Layout1(){
        let { data1, } = this.state
        let { year ,plt_bld_id } = this.props
        return <div>
                <h1>สรุปผลการตรวจสอบและรับรองการจัดการพลังงาน</h1>
                <h2>1) สรุปผลแต่ละขั้นตอน</h2>
                <table style={{borderSpacing:'1px 1px'}}>
                <tr>
                    <th style={{textAlign:'center'}}>ขั้นตอน</th>
                    <th style={{textAlign:'center'}}>ผลการตรวจประเมิน</th>
                    <th style={{textAlign:'center'}}>ข้อคิดเห็นการปรับปรุงวิธีการดำเนินการจัดการพลังงาน</th>
                </tr>
                <tbody>
                { data1.map((r)=>{
                    return <tr>
                            <td >{r.LIST_DESC}</td>
                            <td style={{textAlign:'center'}}>{r.RESULT_FLAG == '1'?'สอดคล้อง':''}</td>
                            <td style={{textAlign:'center'}}>{r.REMARK}</td>
                        </tr>
                    
                })
                    
                }
                </tbody>
                </table>
                <span style={{display:'block', textAlign:'right'}}>
               <ul className="myNavigation">
                        <li>
                            <button type="button"  className="myButton1" style={{verticalAlign:'top','height':'32px'}}
                            onClick={()=>{
                                   let { listTable } = this.state;
                                    listTable = listTable.map((r,i)=>{
                                    let d = {RESULT_FLAG:'',REMARK:''}
                                    for(let j in data1){
                                        if(data1[j].LIST_C == "0"+(i+1)){
                                            d = data1[j];
                                        }
                                    }
                                    console.log(d);
                                    d.UPDATE = false;
                                    return {...r,...d}
                                })
                                this.setState({listTable:listTable,visible1:true})
                                
                                }}>
                                <img src="images/iPencil.png"/>&nbsp;แก้ไข
                            </button>
                        </li>
                    </ul></span>
                </div>
    }

       Layout2(){
        let { data2 } = this.state
        return <div>
               
                {
                data2.map((d)=>{
                return <div>
                     <h2>2) สรุปผลการตรวจสอบ</h2>
                        <table style={{borderSpacing:'1px 1px'}}>
                            <tbody>
                                {this.choice(d.PASS_FLAG == '1',"PASS_FLAG_1")}
                                {this.choice(d.PASS_FLAG == '2',"PASS_FLAG_2",d.NOT_SERIOUS || '-')}
                                {this.choice(d.PASS_FLAG == '3',"PASS_FLAG_3",[d.NOT_PASS_NOT_SERIOUS || '-',d.NOT_PASS_SERIOUS || '-'])}
                            </tbody>
                        </table>
                        <h2>รายละเอียดความไม่สอดคล้องกับข้อกำหนดประเภทไม่ร้ายแรง</h2>
                         <table style={{borderSpacing:'1px 1px'}}>
                            <tbody>
                                  {[1,2,3,4].map((dd)=>{
                                      return this.choice(d['NOT_SERIOUS_NOT_CONFORM_'+dd] == '1','NOT_SERIOUS_NOT_CONFORM_'+dd,d["COMMENT_1_"+dd])
                                  })}
                            </tbody>
                        </table>
                        <h2>รายละเอียดความไม่สอดคล้องกับข้อกำหนดประเภทร้ายแรง</h2>
                        <table style={{borderSpacing:'1px 1px'}}>
                            <tbody>
                                  {[1,2,3,4,5,6,7].map((dd)=>{
                                      return this.choice(d['SERIOUS_NOT_CONFORM_'+dd] == '1','SERIOUS_NOT_CONFORM_'+dd,d["COMMENT_2_"+dd])
                                  })}
                            </tbody>
                        </table>
                        </div>
                       })
                        }
                        <span style={{display:'block', textAlign:'right'}}>
                    <ul className="myNavigation">
                        <li>
                            <button type="button"  className="myButton1" style={{verticalAlign:'top','height':'32px'}}
                            onClick={()=>{
                                this.setState({visible2:true,m2:data2.length>0?{...data2[0]}:{}})
                                }}>
                                <img src="images/iPencil.png"/>&nbsp;แก้ไข
                            </button>
                        </li>
                    </ul>
                </span>
                </div>
    }

    MDLayout1(){
        let { data1,data2 ,visible1 ,listTable} = this.state


        return <div>
               <Modal
                visible={visible1}
                width={1100}
                title="รายละเอียดผลสรุปการตรวจสอบ"
                onOk={()=>{}}
                onCancel={()=>{this.setState({visible1:false})}}
                footer={[
                    <Button key="back" onClick={()=>{
                        this.setState({visible1:false})
                        
                    }}>ปิด</Button>,
                    <Button key="submit" type="primary" loading={false} onClick={()=>{
                        let { listTable } = this.state;
                        let update = [],insert = [];
                        listTable.forEach((l,i)=>{
                            if(l.UPDATE){
                                if(l.LIST_C){
                                    //update
                                    update.push({LIST_C:l.LIST_C,RESULT_FLAG:l.RESULT_FLAG,REMARK:l.REMARK})
                                }else{
                                    // insert
                                    insert.push({LIST_C:(i+1),RESULT_FLAG:l.RESULT_FLAG,REMARK:l.REMARK})
                                }
                            }

                        })
                        if(update.length > 0 || insert.length > 0){
                            this.insertUpdateDeleteDataLayout1({update:update,insert:insert,delete:[]})
                            console.log(update,insert)
                        }else{
                            this.setState({visible1:false})
                        }

                    }}>
                    บันทึกข้อมูล
                    </Button>,
                ]}
                >
               <table>
                <thead><tr>
                <th width="45">&nbsp;</th>
                <th>ขั้นตอน</th>
                <th style={{textAlign:'center'}} width="220">ผลการตรวจประเมิน</th>
                <th style={{textAlign:'center'}} width="200">ข้อคิดเห็นการปรับปรุงวิธีการดำเนินการจัดการพลังงาน</th>
                <th style={{textAlign:'center'}} width="50">ลบ</th>
                </tr>
                </thead>
                <tbody>
                    {
            listTable.map((d,i)=>{
                return  <tr>
                            <th style={{textAlign:'center'}}>{i+1}</th>
                            <td >&nbsp;{d.text}&nbsp;</td>
                            <td style={{textAlign:'center'}}>
                             <RadioGroup onChange={(e) => {
                                 console.log(e)
                                    listTable[i].RESULT_FLAG = e.target.value;
                                    listTable[i].UPDATE = true
                                    this.setState({listTable:listTable})
                                }}value={d.RESULT_FLAG}>
                                    <Radio value={'1'}>สอดคล้อง</Radio>
                                    <Radio value={''}>ไม่สอดคล้อง</Radio>
                                </RadioGroup>
                                {/* <Datetimepicker name={"AUDIT-D-"+i} value={d.AUDIT_D} onSelect={(value) => {
                                    listTable[i].AUDIT_D = value
                                    listTable[i].UPDATE = true

                                    this.setState({listTable:listTable})
                                }}/> */}
                            </td>
                            <td style={{textAlign:'center'}}>
                            <input type="textbox" value={d.REMARK} size="40" maxlength="80"
                            onChange={(e)=>{

                                    listTable[i].REMARK = e.target.value;
                                    listTable[i].UPDATE = true

                                    this.setState({ listTable: listTable })
                                }}
                            />
                             </td>
                            <td style={{textAlign:'center'}}>
                            { d.LIST_C?
                                <a onClick={()=>{
                                    if(window.confirm("คุณต้องการลบ?")){
                                        this.insertUpdateDeleteDataLayout1({update:[],insert:[],delete:[{LIST_C:d.LIST_C}]})
                                    }
                                        
                                    }}><img width="18" height="18" src="images/iTrash.png"/></a>
                                :null
                                }
                            </td>
                        </tr>
                        })
                    }

                </tbody>
                </table>
                </Modal>
            </div>
    }

        MDLayout2(){
        let { data1,data2 ,visible2,m2 } = this.state
        return <div>
               <Modal
                visible={visible2}
                width={900}
                title="สรุปผลการตรวจสอบและรับรองการจัดการด้านพลังงาน"
                onOk={()=>{}}
                onCancel={()=>{this.setState({visible2:false})}}
                footer={[
                    <Button key="back" onClick={()=>{this.setState({visible2:false})}}>ปิด</Button>,
                    <Button key="submit" type="primary" loading={false} onClick={()=>{
                        this.putDataLayout2()
                    }}>
                    บันทึกข้อมูล
                    </Button>,
                ]}
                >
               <table>
				<tbody>
                    {/* <tr>
					<td></td><td><input type="hidden" name="PLT_BLD_ID" value="5507769"></td>
				</tr>
				<tr>
					<td></td><td><input type="hidden" name="TIME" value="1"></td>
				</tr> */}
				<tr>
					<td>สรุปผลการตรวจสอบ</td>
                    <td>
                        {/* <input type="radio" name="PASS_FLAG" className="radio" onchange="ef060c06_pass()" value="1" checked=""/>
                        ผ่านการตรวจสอบ
                        <input type="radio" name="PASS_FLAG" className="radio" onchange="ef060c06_pass()" value="2"/>
                        ผ่านการตรวจสอบแต่ต้องปรับปรุงในปีถัดไป
                        <input type="radio" name="PASS_FLAG" className="radio" onchange="ef060c06_pass()" value="3"/>
                        ไม่ผ่านการตรวจสอบ */}

                          <RadioGroup onChange={(e) => {
                            console.log(e)
                            m2.PASS_FLAG = e.target.value;
                            this.setState({m2:m2})
                        }}value={m2.PASS_FLAG}>
                            <Radio value={'1'}>ผ่านการตรวจสอบ</Radio>
                            <Radio value={'2'}>ผ่านการตรวจสอบแต่ต้องปรับปรุงในปีถัดไป</Radio>
                            <Radio value={'3'}>ไม่ผ่านการตรวจสอบ</Radio>
                        </RadioGroup>

                    </td>
				</tr>
				<tr>
					<td><u>กรณีผ่านการตรวจสอบแต่ต้องปรับปรุงในปีหน้า</u></td><td>&nbsp;</td>
				</tr>
				<tr>
					<td align="right">ไม่สอดคล้องอย่างไม่ร้ายแรง (จำนวนข้อ)</td><td>
                        <Input  name="NOT_SERIOUS" value={m2.NOT_SERIOUS} size="80" maxlength="500"
                            onChange={(e)=>{
                                console.log(e)
                                m2.NOT_SERIOUS = e.target.value
                                this.setState({m2:m2})
                            }}
                            style={{width: '200px'}}/>
                        {/* <input type="textbox" name="NOT_SERIOUS" className="textbox" value="" size="5" maxlength="22"/> */}
                        </td>
				</tr>
				<tr>
					<td><u>กรณีไม่ผ่านการตรวจสอบ</u></td><td>&nbsp;</td>
				</tr>		
				<tr>
					<td align="right">ไม่สอดคล้องอย่างไม่ร้ายแรง  (จำนวนข้อ)</td><td>
                        {/* <input type="textbox" name="NOT_PASS_NOT_SERIOUS" className="textbox" value="" size="5" maxlength="22"/> */}
                        <Input  name="NOT_PASS_NOT_SERIOUS" value={m2.NOT_PASS_NOT_SERIOUS} size="80" maxlength="500"
                            onChange={(e)=>{
                                console.log(e)
                                m2.NOT_PASS_NOT_SERIOUS = e.target.value
                                this.setState({m2:m2})
                            }}
                            style={{width: '200px'}}/>
                        </td>
				</tr>
				<tr>
					<td align="right">ไม่สอดคล้องอย่างร้ายแรง  (จำนวนข้อ)</td><td>
                        {/* <input type="textbox" name="NOT_PASS_SERIOUS" className="textbox" value="" size="5" maxlength="22"/> */}
                        <Input  name="NOT_PASS_SERIOUS" value={m2.NOT_PASS_SERIOUS} size="80" maxlength="500"
                            onChange={(e)=>{
                                console.log(e)
                                m2.NOT_PASS_SERIOUS = e.target.value
                                this.setState({m2:m2})
                            }}
                            style={{width: '200px'}}/>
                        </td>
				</tr>
				<tr>
					<td colspan="2">
						<hr/>
					</td>
				</tr>
			</tbody></table>

            <table>
				<tbody><tr>
					<th colspan="2" align="left"><u>รายละเอียดความไม่สอดคล้องกับข้อกำหนดประเภทไม่ร้ายแรง</u></th>
				</tr>
				<tr>
					<td>
                        <Checkbox checked={m2.NOT_SERIOUS_NOT_CONFORM_1 == '1'?true:false} size="80" maxlength="500"
                            onChange={(e)=>{
                                console.log(e)
                                m2.NOT_SERIOUS_NOT_CONFORM_1 = e.target.checked?'1':''
                                this.setState({m2:m2})
                            }}
                            >
                        </Checkbox>
                        
                        {/* <input type="checkbox" name="NOT_SERIOUS_NOT_CONFORM_1" className="checkbox" value="1"/> */}
                    </td>
                    <td>(ข.1) การมีคำสั่งแต่งตั้งคณะทำงานด้านการจัดการพลังงานการมีคำสั่งแต่งตั้งคณะผู้ตรวจประเมินการจัดการพลังงานภายในองค์กรและการมีนโยบายอนุรักษ์พลังงานเป็นเอกสารแต่ยังไม่ได้ลงลายมือชื่อโดยเจ้าของโรงงานควบคุมหรือเจ้าของอาคารควบคุม</td>
				</tr>
				<tr>
					<td>ระบุ</td>
                    <td>
                        {/* <textarea name="COMMENT_1_1" cols="130" rows="3"  className=""></textarea> */}
                        
                        <TextArea  value={m2.COMMENT_1_1} size="80" maxlength="500"
                            onChange={(e)=>{
                                console.log(e)
                                m2.COMMENT_1_1 = e.target.value
                                this.setState({m2:m2})
                            }}
                            style={{width: '200px'}}/>
                        </td>
				</tr>
				<tr>
					<td>
                        {/* <input type="checkbox" name="NOT_SERIOUS_NOT_CONFORM_2" className="checkbox" value="1"/> */}
                        <Checkbox checked={m2.NOT_SERIOUS_NOT_CONFORM_2 == '1'?true:false} 
                            onChange={(e)=>{
                                console.log(e)
                                m2.NOT_SERIOUS_NOT_CONFORM_2 = e.target.checked?'1':''
                                this.setState({m2:m2})
                            }}
                            >
                        </Checkbox>

</td><td>(ข.2) การกำหนดอำนาจหน้าที่และความรับผิดชอบของคณะทำงานด้านการจัดการพลังงานสอดคล้องกับสาระสำคัญบางข้อตามที่กำหนดไว้ในกฎกระทรวงการประเมินสถานภาพการจัดการพลังงานเบื้องต้นไม่ครบทุกหน่วยงานย่อยตามโครงสร้างของโรงงานควบคุมหรืออาคารควบคุมหรือการประเมินสถานภาพการจัดการพลังงานเบื้องต้นไม่ครบทุกองค์ประกอบตามที่กำหนด การกำหนดนโยบายอนุรักษ์สอดคล้องกับสาระสำคัญบางข้อตามที่กำหนดในกฎกระทรวง มีการประเมินศักยภาพการอนุรักษ์พลังงานการตรวจประเมินการจัดการพลังงานและการทบทวนวิเคราะห์และแก้ไขข้อบกพร่องของการจัดการพลังงานในบางข้อหรือไม่ครบทุกองค์ประกอบตามหลักเกณฑ์และวิธีการกำหนดในประกาศกระทรวง</td>
				</tr>
				<tr>
					<td>ระบุ</td><td>
                        {/* <textarea name="COMMENT_1_2" cols="130" rows="3"  className=""></textarea> */}
                         <TextArea  value={m2.COMMENT_1_2} size="80" maxlength="500"
                            onChange={(e)=>{
                                console.log(e)
                                m2.COMMENT_1_2 = e.target.value
                                this.setState({m2:m2})
                            }}
                            style={{width: '200px'}}/>
                        </td>
				</tr>
				<tr>
					<td>
                        {/* <input type="checkbox" name="NOT_SERIOUS_NOT_CONFORM_3" className="checkbox" value="1"/> */}
                         <Checkbox checked={m2.NOT_SERIOUS_NOT_CONFORM_3 == '1'?true:false} 
                            onChange={(e)=>{
                                console.log(e)
                                m2.NOT_SERIOUS_NOT_CONFORM_3 = e.target.checked?'1':''
                                this.setState({m2:m2})
                            }}
                            >
                        </Checkbox>
</td><td>(ข.3) ผลการตรวจวัดและวิเคราะห์ข้อมูลที่ได้จากการประเมินศักยภาพการอนุรักษ์พลังงานรวมถึงผลการตรวจสอบและวิเคราะห์ข้อมูลที่ใช้ในการกำหนดมาตรการอนุรักษ์พลังงานด้านไฟฟ้าและด้านความร้อนและผลการตรวจสอบและวิเคราะห์ข้อมูลการปฏิบัติตามเป้าหมายและแผนอนุรักษ์พลังงานในแต่ละมาตรการไม่ถูกต้องตามหลักวิศวกรรมผลการติดตามการจัดฝึกอบรมและกิจกรรมเพื่อส่งเสริมการอนุรักษ์พลังงานไม่เป็นไปตามแผนที่กำหนดไว้</td>
				</tr>
				<tr>
					<td>ระบุ</td>
                    <td>
                        {/* <textarea name="COMMENT_1_3" cols="130" rows="3" className=""></textarea> */}
                         <TextArea  value={m2.COMMENT_1_3} size="80" maxlength="500"
                            onChange={(e)=>{
                                console.log(e)
                                m2.COMMENT_1_3 = e.target.value
                                this.setState({m2:m2})
                            }}
                            style={{width: '200px'}}/>
                        </td>
				</tr>
				<tr>
					<td>
                        {/* <input type="checkbox" name="NOT_SERIOUS_NOT_CONFORM_4" className="checkbox" value="1"/> */}
                        <Checkbox checked={m2.NOT_SERIOUS_NOT_CONFORM_4 == '1'?true:false} 
                            onChange={(e)=>{
                                console.log(e)
                                m2.NOT_SERIOUS_NOT_CONFORM_4 = e.target.checked?'1':''
                                this.setState({m2:m2})
                            }}
                            >
                        </Checkbox>
</td><td>(ข.4) มีการเผยแพร่คำสั่งแต่งตั้งคณะทำงานด้านการจัดการพลังงานคำสั่งแต่งตั้งคณะผู้ตรวจประเมินการจัดการพลังงานภายในองค์การนโยบายอนุรักษ์พลังงานแผนการฝึกอบรมและกิจกรรมเพื่อส่งเสริมการอนุรักษ์พลังงานด้วยวิธีการใดวิธีการหนึ่งแล้วแต่บุคลากรของโรงงานควบคุมหรืออาคารควบคุมได้รับทราบไม่ทั่วถึงเป็นต้น</td>
				</tr>
				<tr>
					<td>ระบุ</td><td>
                        {/* <textarea name="COMMENT_1_4" cols="130" rows="3" className=""></textarea> */}
                         <TextArea  value={m2.COMMENT_1_4} size="80" maxlength="500"
                            onChange={(e)=>{
                                console.log(e)
                                m2.COMMENT_1_4 = e.target.value
                                this.setState({m2:m2})
                            }}
                            style={{width: '200px'}}/>
                        </td>
				</tr>
				<tr>
					<th colspan="2" align="left"><u>รายละเอียดความไม่สอดคล้องกับข้อกำหนดประเภทร้ายแรง</u></th>
				</tr>
				<tr>
					<td>
                        {/* <input type="checkbox" name="SERIOUS_NOT_CONFORM_1" className="checkbox" value="1"/> */}
                        <Checkbox checked={m2.SERIOUS_NOT_CONFORM_1 == '1'?true:false} 
                            onChange={(e)=>{
                                console.log(e)
                                m2.SERIOUS_NOT_CONFORM_1 = e.target.checked?'1':''
                                this.setState({m2:m2})
                            }}
                            >
                        </Checkbox>
</td><td>(ก.1) การไม่มีคำสั่งแต่งตั้งคณะทำงานด้านการจัดการพลังงานเป็นเอกสาร การไม่กำหนดอำนาจหน้าที่และความรับผิดชอบของคณะทำงานด้านการจัดการพลังงานตามที่กำหนดไว้ในกฎกระทรวง</td>
				</tr>
				<tr>
					<td>ระบุ</td>
                    <td>
                        {/* <textarea name="COMMENT_2_1" cols="130" rows="3"  className=""></textarea> */}
                         <TextArea  value={m2.COMMENT_2_1} size="80" maxlength="500"
                            onChange={(e)=>{
                                console.log(e)
                                m2.COMMENT_2_1 = e.target.value
                                this.setState({m2:m2})
                            }}
                            style={{width: '200px'}}/>
                        </td>
				</tr>
				<tr>
					<td>
                        {/* <input type="checkbox" name="SERIOUS_NOT_CONFORM_2" className="checkbox" value="1"/> */}
                        <Checkbox checked={m2.SERIOUS_NOT_CONFORM_2 == '1'?true:false} 
                            onChange={(e)=>{
                                console.log(e)
                                m2.SERIOUS_NOT_CONFORM_2 = e.target.checked?'1':''
                                this.setState({m2:m2})
                            }}
                            >
                        </Checkbox>
</td><td>(ก.2) การไม่ประเมินสถานภาพการจัดการพลังงานเบื้องต้นทั้งในหน่วยงานย่อยตามโครงสร้างและภาพรวมของโรงงานควบคุมหรืออาคารควบคุมในกรณีที่มีการนำวิธีการจัดการพลังงานมาใช้เป็นครั้งแรก</td>
				</tr>
				<tr>
					<td>ระบุ</td>
                    <td>
                        {/* <textarea name="COMMENT_2_2" cols="130" rows="3"  className=""></textarea> */}
                         <TextArea  value={m2.COMMENT_2_2} size="80" maxlength="500"
                            onChange={(e)=>{
                                console.log(e)
                                m2.COMMENT_2_2 = e.target.value
                                this.setState({m2:m2})
                            }}
                            style={{width: '200px'}}/>
                    </td>
				</tr>
				<tr>
					<td>
                        {/* <input type="checkbox" name="SERIOUS_NOT_CONFORM_3" claclassNamess="checkbox" value="1"/> */}
                        <Checkbox checked={m2.SERIOUS_NOT_CONFORM_3 == '1'?true:false} 
                            onChange={(e)=>{
                                console.log(e)
                                m2.SERIOUS_NOT_CONFORM_3 = e.target.checked?'1':''
                                this.setState({m2:m2})
                            }}
                            >
                        </Checkbox>
</td><td>(ก.3) การไม่มีนโยบานอนุรักษ์พลังงานเป็นเอกสารการไม่กำหนดนโยบายอนุรักษ์พลังงานให้มีสาระสำคัญตามที่กำหนดไว้ในกฎกระทรวงการไม่ประเมินศักยภาพการอนุรักษ์พลังงานตามหลักเกณฑ์และวิธีการในข้อใดเลยที่กำหนดไว้ในประกาศ</td>
				</tr>
				<tr>
					<td>ระบุ</td>
                    <td>
                        {/* <textarea name="COMMENT_2_3" cols="130" rows="3" className=""></textarea> */}
                         <TextArea  value={m2.COMMENT_2_3} size="80" maxlength="500"
                            onChange={(e)=>{
                                console.log(e)
                                m2.COMMENT_2_3 = e.target.value
                                this.setState({m2:m2})
                            }}
                            style={{width: '200px'}}/>
                        </td>
				</tr>
				<tr>
					<td>
                        {/* <input type="checkbox" name="SERIOUS_NOT_CONFORM_4" className="checkbox" value="1"/> */}
                            <Checkbox checked={m2.SERIOUS_NOT_CONFORM_4 == '1'?true:false} 
                            onChange={(e)=>{
                                console.log(e)
                                m2.SERIOUS_NOT_CONFORM_4 = e.target.checked?'1':''
                                this.setState({m2:m2})
                            }}
                            >
                        </Checkbox>

</td><td>(ก.4) การไม่กำหนดเป้าหมายและแผนอนุรักษ์พลังงานตามหลักเกณฑ์และวิธีการที่กำหนดในประกาศ การไม่กำหนดแผนการฝึกอบรมและกิจกรรมเพื่อส่งเสริมการอนุรักษ์พลังงาน</td>
				</tr>
				<tr>
					<td>ระบุ</td>
                    <td>
                        {/* <textarea name="COMMENT_2_4" cols="130" rows="3" className=""></textarea> */}
                        <TextArea  value={m2.COMMENT_2_4} size="80" maxlength="500"
                            onChange={(e)=>{
                                console.log(e)
                                m2.COMMENT_2_4 = e.target.value
                                this.setState({m2:m2})
                            }}
                            style={{width: '200px'}}/>
                        </td>
				</tr>
				<tr>
					<td>
                        
                        {/* <input type="checkbox" name="SERIOUS_NOT_CONFORM_5" className="checkbox" value="1"/> */}
                    <Checkbox checked={m2.SERIOUS_NOT_CONFORM_5 == '1'?true:false} 
                            onChange={(e)=>{
                                console.log(e)
                                m2.SERIOUS_NOT_CONFORM_5 = e.target.checked?'1':''
                                this.setState({m2:m2})
                            }}
                            >
                        </Checkbox>


</td><td>(ก.5) การไม่ดำเนินการตรวจสอบและวิเคราะห์การปฏิบัติตามเป้าหมายและแผนอนุรักษ์พลังงานตามหลักเกณฑ์และวิธีการกำหนดในประกาศการไม่ติดตามผลการดำเนินการของการฝึกอบรมและกิจกรรมเพื่อส่งเสริมการอนุรักษ์พลังงาน</td>
				</tr>
				<tr>
					<td>ระบุ</td>
                    <td>
                        {/* <textarea name="COMMENT_2_5" cols="130" rows="3" className=""></textarea> */}
                        <TextArea  value={m2.COMMENT_2_5} size="80" maxlength="500"
                            onChange={(e)=>{
                                console.log(e)
                                m2.COMMENT_2_5 = e.target.value
                                this.setState({m2:m2})
                            }}
                            style={{width: '200px'}}/>
                        </td>
				</tr>
				<tr>
					<td>
                        {/* <input type="checkbox" name="SERIOUS_NOT_CONFORM_6" className="checkbox" value="1"/> */}
                        <Checkbox checked={m2.SERIOUS_NOT_CONFORM_6 == '1'?true:false} 
                            onChange={(e)=>{
                                console.log(e)
                                m2.SERIOUS_NOT_CONFORM_6 = e.target.checked?'1':''
                                this.setState({m2:m2})
                            }}
                            >
                        </Checkbox>

</td><td>(ก.6) การไม่มีคำสั่งแต่งตั้งคณะผู้ตรวจประเมินการจัดการพลังงานภายในองค์การเป็นเอกสาร การไม่ตรวจประเมินการจัดการพลังงานตามหลักเกณฑ์และวิธีการที่กำหนดในประกาศการไม่ทบทวนวิเคราะห์และแก้ไขข้อบกพร่องของการจัดการพลังงานตามหลักเกณฑ์และวิธีการที่กำหนดในประกาศการไม่นำผลการตรวจติดตามและประเมินการจัดการพลังงานนำเสนอคณะทำงานด้านการจัดการพลังงานเพื่อทบทวนวิเคราะห์และแก้ไขข้อบกพร่องของการจัดการพลังงานในรอบปี  การไม่มีผลการทบทวนวิเคราะห์และแก้ไขข้อบกพร่องของการจัดการพลังงาน</td>
				</tr>
				<tr>
					<td>ระบุ</td>
                    <td>
                        {/* <textarea name="COMMENT_2_6" cols="130" rows="3" className=""></textarea> */}
                             <TextArea  value={m2.COMMENT_2_6} size="80" maxlength="500"
                            onChange={(e)=>{
                                console.log(e)
                                m2.COMMENT_2_6 = e.target.value
                                this.setState({m2:m2})
                            }}
                            style={{width: '200px'}}/>
                        </td>
				</tr>
				<tr>
					<td>
                        {/* <input type="checkbox" name="SERIOUS_NOT_CONFORM_7" className="checkbox" value="1"/> */}
                        <Checkbox checked={m2.SERIOUS_NOT_CONFORM_7 == '1'?true:false} 
                            onChange={(e)=>{
                                console.log(e)
                                m2.SERIOUS_NOT_CONFORM_7 = e.target.checked?'1':''
                                this.setState({m2:m2})
                            }}
                            >
                        </Checkbox>

</td><td>(ก.7) การไม่เผยแพร่คำสั่งแต่งตั้งคณะทำงานการจัดการพลังงานการไม่เผยแพร่คำสั่งแต่งตั้งคณะผู้ตรวจประเมินการจัดการพลังงานภายในองค์กรรวมถึงการไม่เผยแพร่ในเรื่องของนโยบายอนุรักษ์พลังงานแผนการฝึกอบรมและกิจกรรมเพื่อส่งเสริมการอนุรักษ์พลังงานด้วยวิธีการใดๆ ให้บุคคลากรในโรงงานควบคุมหรืออาคารควบคุมทราบอย่างทั่วถึง</td>
				</tr>
				<tr>
					<td>ระบุ</td>
                    <td>
                        {/* <textarea name="COMMENT_2_7" cols="130" rows="3" className=""></textarea> */}
                        <TextArea  value={m2.COMMENT_2_7} size="80" maxlength="500"
                            onChange={(e)=>{
                                console.log(e)
                                m2.COMMENT_2_7 = e.target.value
                                this.setState({m2:m2})
                            }}
                            style={{width: '200px'}}/>
                        </td>
				</tr>
				<tr>
					<td colspan="2" align="right">
&nbsp;
					</td>
				</tr>
			</tbody></table>


                </Modal>
            </div>
    }

     choice($result,$var,$detail='')
	{   
        let $choice = '',$data = ''

		if ($detail != '' || $detail != 'x')
		{
			$data = this.label($var,$detail);
		}
		else
		{
			$data = this.label($var);
		}
    return <tr>
                <td >{$result?
                    <img  src='images/icheck.png'/>:
                    <img  src='images/iuncheck.png'/>}
                </td ><td >
                {$data}
                {$detail}
                </td >
            </tr>
    }
    
    label($var,$n)
	{
        let $stm = ''
		switch ($var)
		{
			case "NOT_SERIOUS_NOT_CONFORM_1":
				$stm = "(ข.1) การมีคำสั่งแต่งตั้งคณะทำงานด้านการจัดการพลังงานการมีคำสั่งแต่งตั้งคณะผู้ตรวจประเมินการจัดการพลังงานภายในองค์กรและการมีนโยบายอนุรักษ์พลังงานเป็นเอกสารแต่ยังไม่ได้ลงลายมือชื่อโดยเจ้าของโรงงานควบคุมหรือเจ้าของอาคารควบคุม";
				break;
			case "NOT_SERIOUS_NOT_CONFORM_2":
				$stm = "(ข.2) การกำหนดอำนาจหน้าที่และความรับผิดชอบของคณะทำงานด้านการจัดการพลังงานสอดคล้องกับสาระสำคัญบางข้อตามที่กำหนดไว้ในกฎกระทรวงการประเมินสถานภาพการจัดการพลังงานเบื้องต้นไม่ครบทุกหน่วยงานย่อยตามโครงสร้างของโรงงานควบคุมหรืออาคารควบคุมหรือการประเมินสถานภาพการจัดการพลังงานเบื้องต้นไม่ครบทุกองค์ประกอบตามที่กำหนด การกำหนดนโยบายอนุรักษ์สอดคล้องกับสาระสำคัญบางข้อตามที่กำหนดในกฎกระทรวง มีการประเมินศักยภาพการอนุรักษ์พลังงานการตรวจประเมินการจัดการพลังงานและการทบทวนวิเคราะห์และแก้ไขข้อบกพร่องของการจัดการพลังงานในบางข้อหรือไม่ครบทุกองค์ประกอบตามหลักเกณฑ์และวิธีการกำหนดในประกาศกระทรวง";
				break;
			case "NOT_SERIOUS_NOT_CONFORM_3":
				$stm = "(ข.3) ผลการตรวจวัดและวิเคราะห์ข้อมูลที่ได้จากการประเมินศักยภาพการอนุรักษ์พลังงานรวมถึงผลการตรวจสอบและวิเคราะห์ข้อมูลที่ใช้ในการกำหนดมาตรการอนุรักษ์พลังงานด้านไฟฟ้าและด้านความร้อนและผลการตรวจสอบและวิเคราะห์ข้อมูลการปฏิบัติตามเป้าหมายและแผนอนุรักษ์พลังงานในแต่ละมาตรการไม่ถูกต้องตามหลักวิศวกรรมผลการติดตามการจัดฝึกอบรมและกิจกรรมเพื่อส่งเสริมการอนุรักษ์พลังงานไม่เป็นไปตามแผนที่กำหนดไว้";
				break;
			case "NOT_SERIOUS_NOT_CONFORM_4":
				$stm = "(ข.4) มีการเผยแพร่คำสั่งแต่งตั้งคณะทำงานด้านการจัดการพลังงานคำสั่งแต่งตั้งคณะผู้ตรวจประเมินการจัดการพลังงานภายในองค์การนโยบายอนุรักษ์พลังงานแผนการฝึกอบรมและกิจกรรมเพื่อส่งเสริมการอนุรักษ์พลังงานด้วยวิธีการใดวิธีการหนึ่งแล้วแต่บุคลากรของโรงงานควบคุมหรืออาคารควบคุมได้รับทราบไม่ทั่วถึงเป็นต้น";
				break;
			case "SERIOUS_NOT_CONFORM_1":
				$stm = "(ก.1) การไม่มีคำสั่งแต่งตั้งคณะทำงานด้านการจัดการพลังงานเป็นเอกสาร การไม่กำหนดอำนาจหน้าที่และความรับผิดชอบของคณะทำงานด้านการจัดการพลังงานตามที่กำหนดไว้ในกฎกระทรวง";
				break;
			case "SERIOUS_NOT_CONFORM_2":
				$stm = "(ก.2) การไม่ประเมินสถานภาพการจัดการพลังงานเบื้องต้นทั้งในหน่วยงานย่อยตามโครงสร้างและภาพรวมของโรงงานควบคุมหรืออาคารควบคุมในกรณีที่มีการนำวิธีการจัดการพลังงานมาใช้เป็นครั้งแรก";
				break;
			case "SERIOUS_NOT_CONFORM_3":
				$stm = "(ก.3) การไม่มีนโยบานอนุรักษ์พลังงานเป็นเอกสารการไม่กำหนดนโยบายอนุรักษ์พลังงานให้มีสาระสำคัญตามที่กำหนดไว้ในกฎกระทรวงการไม่ประเมินศักยภาพการอนุรักษ์พลังงานตามหลักเกณฑ์และวิธีการในข้อใดเลยที่กำหนดไว้ในประกาศ";
				break;
			case "SERIOUS_NOT_CONFORM_4":
				$stm = "(ก.4) การไม่กำหนดเป้าหมายและแผนอนุรักษ์พลังงานตามหลักเกณฑ์และวิธีการที่กำหนดในประกาศ การไม่กำหนดแผนการฝึกอบรมและกิจกรรมเพื่อส่งเสริมการอนุรักษ์พลังงาน";
				break;
			case "SERIOUS_NOT_CONFORM_5":
				$stm = "(ก.5) การไม่ดำเนินการตรวจสอบและวิเคราะห์การปฏิบัติตามเป้าหมายและแผนอนุรักษ์พลังงานตามหลักเกณฑ์และวิธีการกำหนดในประกาศการไม่ติดตามผลการดำเนินการของการฝึกอบรมและกิจกรรมเพื่อส่งเสริมการอนุรักษ์พลังงาน";
				break;
			case "SERIOUS_NOT_CONFORM_6":
				$stm = "(ก.6) การไม่มีคำสั่งแต่งตั้งคณะผู้ตรวจประเมินการจัดการพลังงานภายในองค์การเป็นเอกสาร การไม่ตรวจประเมินการจัดการพลังงานตามหลักเกณฑ์และวิธีการที่กำหนดในประกาศการไม่ทบทวนวิเคราะห์และแก้ไขข้อบกพร่องของการจัดการพลังงานตามหลักเกณฑ์และวิธีการที่กำหนดในประกาศการไม่นำผลการตรวจติดตามและประเมินการจัดการพลังงานนำเสนอคณะทำงานด้านการจัดการพลังงานเพื่อทบทวน";
				break;
			case "SERIOUS_NOT_CONFORM_7" :
				$stm = "(ก.7) การไม่เผยแพร่คำสั่งแต่งตั้งคณะทำงานการจัดการพลังงานการไม่เผยแพร่คำสั่งแต่งตั้งคณะผู้ตรวจประเมินการจัดการพลังงานภายในองค์กรรวมถึงการไม่เผยแพร่ในเรื่องของนโยบายอนุรักษ์พลังงานแผนการฝึกอบรมและกิจกรรมเพื่อส่งเสริมการอนุรักษ์พลังงานด้วยวิธีการใดๆ ให้บุคคลากรในโรงงานควบคุมหรืออาคารควบคุมทราบอย่างทั่วถึง วิเคราะห์และแก้ไขข้อบกพร่องของการจัดการพลังงานในรอบปี  การไม่มีผลการทบทวนวิเคราะห์และแก้ไขข้อบกพร่องของการจัดการพลังงาน";
				break;
			case "PASS_FLAG_1" :
				$stm = "ผ่านการตรวจสอบ เนื่องจากเจ้าของอาคารควบคุม ปฏิบัติตามข้อกำหนดถูกต้องและครบถ้วนทุกข้อ";
				break;
			case "PASS_FLAG_2" :
				$stm = "ผ่านการตรวจสอบ แต่ต้องปรับปรุงในปีถัดไปเนื่องจากเจ้าของอาคารควบคุม ปฏิบัติตามข้อกำหนดไม่ครบทุกข้อ หรือข้อบกพร่องบางประการไม่สอดคล้องกับข้อกำหนดอย่างไม่ร้ายแรงจำนวน "+$n+" ข้อ";
				break;
			case "PASS_FLAG_3" :
				if ($n[0] == '')
				{
					$n[0] = '-';
				}
				
				if ($n[1] == '')
				{
					$n[1] = '-';
				}
				
				$stm = "ไม่ผ่านการตรวจสอบ เนื่องจากเจ้าของอาคารควบคุมดำเนินการจัดการพลังงานไม่สอดคล้องกับข้อกำหนดอย่างร้ายแรงจำนวน  "+$n[0]+" ข้อและปฏิบัติตามข้อกำหนดไม่ครบทุกข้อ หรือข้อบกพร่องบางประการไม่สอดคล้องกับข้อกำหนดอย่างไม่ร้ายแรงจำนวน  "+$n[1]+" ข้อ";
				break;
		}
		return ($stm);
	}

  render() {
     let {modeLayout1 ,modeLayout2 ,modeLayout3 ,modeLayout4 } = this.state

    return <div>
                <div className='myForm-2' style={{minHeight:'530px'}}>
                    {this.MDLayout2()}
                    {this.MDLayout1()}
                    {this.Layout1()}
                    {this.Layout2()} 
                    
                </div>
          </div>;
  }
}

export default Xpage6ef06dc11;



// WEBPACK FOOTER //
// ./src/view/main/xpage6/ef06dc11.js